// Admin listing
export const GET_ADMIN_LIST = "GET_ADMIN_LIST";
export const GET_ADMIN_LIST_SUCCESS = "GET_ADMIN_LIST_SUCCESS";
export const GET_ADMIN_LIST_ERROR = "GET_ADMIN_LIST_ERROR";

// Add Admin
export const ADD_ADMIN = "ADD_ADMIN";
export const ADD_ADMIN_SUCCESS = "ADD_ADMIN_SUCCESS";
export const ADD_ADMIN_ERROR = "ADD_ADMIN_ERROR";

// Edit Admin
export const EDIT_ADMIN = "EDIT_ADMIN";
export const EDIT_ADMIN_SUCCESS = "EDIT_ADMIN_SUCCESS";
export const EDIT_ADMIN_ERROR = "EDIT_ADMIN_ERROR";

// Delete Admin
export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_ERROR = "DELETE_ADMIN_ERROR";

// Search and pagination
export const SET_ADMIN_PAGE = "SET_ADMIN_PAGE";
export const SET_ADMIN_SORT_FIELD = "SET_ADMIN_SORT_FIELD";
export const SET_ADMIN_SORT_ORDER = "SET_ADMIN_SORT_ORDER";

